import SelectBox from './molecules/SelectBox';
import Tile from './molecules/Tile';
import PrimaryButton from './molecules/Buttons';
import TileList from './organisms/TileList';


export const SelectBoxComponent = SelectBox;
export const TileComponent = Tile;
export const PrimaryButtonComponent = PrimaryButton;
export const TileListComponent = TileList;
